<div class="c-gp-results-share">
	<div class="c-gp-results-share_content">
		<button as-clipboard data-clipboard-text="{{measurementLink}}" disabled="{{!measurementLink}}">
			<img width="20" height="20" src="{{@shared.assetsHost}}/img/url-icon.svg">
			Copy URL
		</button>

		<button as-clipboard data-clipboard-text="{{markdownResults}}" disabled="{{!showMarkdownResults}}">
			<img width="20" height="20" src="{{@shared.assetsHost}}/img/markdown-icon.svg">
			Copy Markdown
		</button>

		<div class="c-gp-results-share_content_command">
			<span class="c-gp-results-share_content_command_label">
				<i class="fa fa-terminal" aria-hidden="true"></i>
				<span>Replicate in CLI</span>
			</span>

			<span id="share-res-text" class="c-gp-results-share_content_command_value">
				{{cliCommand}}
			</span>

			<button as-clipboard data-clipboard-text="{{cliCommand}}" disabled="{{!cliCommand}}">
				<img width="20" height="20" src="{{@shared.assetsHost}}/img/copy-icon-black.svg">
			</button>
		</div>
	</div>

	{{#if shareResMsg}}
		<div class="c-gp-results-share_warning">{{shareResMsg}}</div>
	{{/if}}
</div>


<script>
	const _ = require('../../assets/js/_');
	const PROBE_STATUS_OFFLINE = _.getProbeStatusOfflineValue();
	const clipboard = require('../../assets/js/decorators/clipboard');
	const ipRegex = require('../../assets/js/utils/ip-regex');
	const { addManagedListener } = require('../../assets/js/utils/listeners');

	component.exports = {
		decorators: {
			clipboard,
		},
		data () {
			return {
				shareResMsg: '',
				markdownResults: '',
				measurementLink: '',
				cliCommand: '',
				showMarkdownResults: false,
			};
		},
		onrender () {
			if (!Ractive.isServer) {
				addManagedListener(this, window, 'historyChange', this.createMeasLink.bind(this));

				// select all share-res text of link on click
				this.observe('testInProgress', (testInProgress) => {
					if (!testInProgress) {
						let shareResTextEl = this.find('#share-res-text');

						shareResTextEl.addEventListener('click', () => {
							window.getSelection().selectAllChildren(shareResTextEl);
						});
					}
				}, { defer: true });

				this.observe('isInfiniteModeRes measurementsMetadata expectedTargetsCnt', () => {
					this.createMeasLink();
				});

				this.observe('isInfiniteModeRes measurementsMetadata testReqParams expectedTargetsCnt', () => {
					this.createCliCommand();
				});

				this.observe('preparedTestResults testReqParams measurementsMetadata measurementLink realTimeTestResResponse isTestStopped testInProgress expectedTargetsCnt', () => {
					this.createMarkdownResults();
				});
			}
		},
		createMeasLink () {
			let measurementsMetadata = this.get('measurementsMetadata') || {};
			let isInfiniteModeRes = this.get('isInfiniteModeRes');
			let expectedTargetsCnt = this.get('expectedTargetsCnt') || 0;

			let origin = this.get('@global.location.origin');
			// regular measurement IDs should be separated by a comma
			let idsDelimiter = ',';
			let measIDsArr = Object.values(measurementsMetadata).map(v => v.measurementId);
			let preparedMeasIDsArr = measIDsArr;

			this.set('shareResMsg', '');

			if (!isInfiniteModeRes && (!expectedTargetsCnt || measIDsArr.length < expectedTargetsCnt)) {
				this.set('measurementLink', '');
				return;
			}

			if (isInfiniteModeRes) {
				// the infinite one by a dot
				idsDelimiter = '.';

				// for infinite get last 10 IDs from oldest to newest
				preparedMeasIDsArr = measIDsArr.slice(-10);

				// show related message for such case
				if (measIDsArr.length >= 10) {
					this.set('shareResMsg', 'For long-running continuous mode measurements, only the last 160 packets are shared via URL.');
				}
			}

			let textToCopy = preparedMeasIDsArr.join(idsDelimiter);

			if (!textToCopy) {
				this.set('measurementLink', '');
				return;
			}

			let urlSearchParams = new URLSearchParams(location.search);
			urlSearchParams.set('measurement', textToCopy);

			this.set('measurementLink', `${origin}?${urlSearchParams.toString()}`);
		},
		quoteShellArg (value, alwaysQuote = true) {
			if (!alwaysQuote && /^[a-zA-Z0-9_.,:/@%+=-]+$/.test(value)) {
				return value;
			}

			let escapedValue = value.replace(/["\\$`]/g, '\\$&');

			// Escape ! outside double quotes: "a"\!"b" becomes a!b in Bash and Zsh.
			return `"${escapedValue.replaceAll('!', '"\\!"')}"`;
		},
		createHttpTargetUrl (target, { protocol = 'HTTPS', port, request = {} } = {}) {
			let host = ipRegex.v6({ exact: true }).test(target) ? `[${target}]` : target;
			let query = request.query?.startsWith('?') ? request.query : request.query ? `?${request.query}` : '';

			let path = request.path?.startsWith('/') ? request.path : `/${request.path || ''}`;
			// encode % without double-encoding existing URL escapes
			path = path.replace(/%(?![a-f\d]{2})/gi, '%25');

			// Literal commas must not become comparison target separators in the CLI.
			return `${protocol.toLowerCase()}://${host}${port ? `:${port}` : ''}${path}${query}`.replaceAll(',', '%2C');
		},
		createCliCommand () {
			let params = this.get('testReqParams') || {};
			let expectedTargetsCnt = this.get('expectedTargetsCnt') || 0;
			let isInfiniteModeRes = this.get('isInfiniteModeRes');
			let type = params.type?.toLowerCase();
			let isHttp = type === 'http';

			if (!type || expectedTargetsCnt > 2) {
				this.set('cliCommand', '');
				return;
			}

			let targets = [ params.target ];

			if (expectedTargetsCnt === 2 && !isInfiniteModeRes) {
				let metadata = Object.values(this.get('measurementsMetadata') || {});
				targets = metadata.map(measurement => measurement.target);

				if (targets.length !== expectedTargetsCnt) {
					this.set('cliCommand', '');
					return;
				}
			}

			let cliTargets = targets.map(target => isHttp ? this.quoteShellArg(this.createHttpTargetUrl(target, params.measurementOptions)) : target);
			let isIp = value => ipRegex({ exact: true, allowBrackets: true }).test(value);

			let cmd = Object.keys(params).reduce((cmd, key) => {
				// test type part
				if (key === 'type') {
					cmd.typePart += ` ${type} ${cliTargets.join(', ')}`;

					if (params.locations && params.locations.length) {
						// measurements that reuse probes store the source measurement ID instead of locations
						let locationStr = typeof params.locations === 'string'
							? params.locations
							: params.locations.map(loc => loc.magic.trim()).join(', ');

						cmd.typePart += ` from ${this.quoteShellArg(locationStr, false)}`;
					}

					if (params.measurementOptions) {
						let str = Object.keys(params.measurementOptions).reduce((str, key) => {
							switch (key) {
								case 'packets':
									if (!isInfiniteModeRes) {
										str += ` --packets ${params.measurementOptions.packets}`;
									}

									break;

								case 'port':
									if (!isHttp) {
										str += ` --port ${params.measurementOptions.port}`;
									}

									break;

								case 'protocol':
									if (!isHttp) {
										str += ` --protocol ${params.measurementOptions.protocol}`;
									}

									break;

								case 'query':
									str += ` --type ${params.measurementOptions.query.type}`; break;

								case 'ipVersion':
									// the CLI rejects --ipv4/--ipv6 with IP targets or resolvers
									if (!targets.some(isIp) && !isIp(params.measurementOptions.resolver || '')) {
										str += ` --ipv${params.measurementOptions.ipVersion}`;
									}

									break;

								case 'trace':
									if (type === 'dns' && params.measurementOptions.trace) {
										str += ' --trace';
									}

									break;

								case 'resolver':
									str += ` --resolver ${params.measurementOptions.resolver}`; break;

								case 'request':
									Object.entries(params.measurementOptions.request.headers || {}).forEach(([ name, value ]) => {
										str += ` --header ${this.quoteShellArg(`${name}: ${value}`)}`;
									});

									if (params.measurementOptions.request.host) {
										str += ` --host ${this.quoteShellArg(params.measurementOptions.request.host, false)}`;
									}

									if (params.measurementOptions.request.method) {
										str += ` --method ${params.measurementOptions.request.method}`;
									}

									break;
							}

							return str;
						}, '');

						cmd.typePart += str;
					}
				}

				// global flags part
				if (key === 'limit') {
					cmd.globalPart += ` --limit ${params[key]}`;
				}

				return cmd;
			}, {
				base: 'globalping',
				typePart: '',
				globalPart: '',
			});

			// add infinite flag for the Infinite flow
			if (isInfiniteModeRes) {
				cmd.globalPart += ' --infinite';
			}

			this.set('cliCommand', cmd.base + cmd.typePart + cmd.globalPart);
		},
		isMarkdownExportReady () {
			let results = this.get('preparedTestResults');
			let testReqParams = this.get('testReqParams');
			let measurementsMetadata = this.get('measurementsMetadata');
			let responses = (this.get('realTimeTestResResponse') || []).filter(Boolean);
			let expectedTargetsCnt = this.get('expectedTargetsCnt') || 0;
			let measurementsCnt = Object.keys(measurementsMetadata || {}).length;
			let isInfiniteModeRes = this.get('isInfiniteModeRes');

			if (!results?.length || !testReqParams?.type || !measurementsMetadata) {
				return false;
			}

			if (isInfiniteModeRes && this.get('isTestStopped')) {
				return true;
			}

			if (isInfiniteModeRes && this.get('testInProgress')) {
				return false;
			}

			if (!responses.length || responses.some(response => response.status !== 'finished')) {
				return false;
			}

			return isInfiniteModeRes || (
				expectedTargetsCnt > 0
				&& measurementsCnt >= expectedTargetsCnt
				&& responses.length >= expectedTargetsCnt
			);
		},
		createMarkdownResults () {
			let results = this.get('preparedTestResults');
			let testReqParams = this.get('testReqParams');
			let measurementsMetadata = this.get('measurementsMetadata');
			this.set('showMarkdownResults', false);

			if (!this.isMarkdownExportReady()) {
				return;
			}

			// create result title consisting of the test type and locations
			let locationStr = testReqParams.locations.map(location => Object.values(location).join('+').trim()).join(', ');

			let testMethod = testReqParams.measurementOptions?.request?.method;
			let dnsTestType = testReqParams.measurementOptions?.query?.type;
			let extraTestInfo = testMethod || dnsTestType;

			let testType = testReqParams.type.toUpperCase();
			let testStr = `${testType}${extraTestInfo ? ` (${extraTestInfo})` : ''}`;
			let resultTitle = `## Globalping: \`${testStr}\` from ${locationStr}\n`;

			// create markdown for each target
			let targetStrings = [];
			let targetNames = Array.from(new Set(Object.values(measurementsMetadata).map(m => m.target)));

			for (let targetIdx = 0; targetIdx < targetNames.length; ++targetIdx) {
				// add target header and iterate over each result (probe)
				let currentTarget = targetNames[targetIdx];
				let targetHeader = `### Target: ${currentTarget}\n\n`;

				let perProbe = results.map((probeStats) => {
					let targetStats = probeStats.statsPerTarget.find(measurement => measurement.target === currentTarget);

					if (!targetStats) {
						return '';
					}

					// HEADER
					let header = `#### ${probeStats.city}, ${probeStats.country}, ${probeStats.continent} - ${probeStats.network} (AS${probeStats.asn})\n`;

					// SUBHEADER (timing etc.)
					let subheaderParts = [];
					let timing = _.getGpTargetTiming(targetStats);

					if (timing) {
						subheaderParts.push({ title: 'Time', value: timing });
					}

					if (!targetStats.isFailed && targetStats.avgTiming !== PROBE_STATUS_OFFLINE && targetStats.extraValues) {
						Object.keys(targetStats.extraValues).forEach((key) => {
							let extraVal = targetStats.extraValues[key];
							subheaderParts.push({ title: extraVal.text, value: `${extraVal.value}${extraVal.units}` });
						});
					}

					if (testReqParams.type === 'http' && targetStats.ipAddr) {
						subheaderParts.push({ title: 'Resolved address', value: targetStats.ipAddr });
					}

					let subheader = subheaderParts.map(({ title, value }) => `${title}: \`${value}\``).join('&nbsp;&nbsp;&nbsp;');

					if (subheader) {
						subheader += '\n';
					}

					// RAW OUTPUT
					let responseBody = targetStats.responseBody ? `\n\n${targetStats.responseBody}` : '';
					let rawOutputContent = ((targetStats.rawOutput ?? '') + responseBody).trim();
					let tickCount = 3;

					for (let tickSequence of rawOutputContent.matchAll(/`+/g)) {
						tickCount = Math.max(tickCount, tickSequence[0].length + 1);
					}

					let tickWrapper = '`'.repeat(tickCount);
					let rawOutputBlock = `${tickWrapper}\n${rawOutputContent}\n${tickWrapper}`;
					let hasContent = !!subheader || !!rawOutputContent;

					// COMPLETE THE STRING
					return hasContent ? `${header}${subheader}${rawOutputBlock}` : '';
				}).filter(Boolean).join('\n\n');

				if (perProbe) {
					this.set('showMarkdownResults', true);
					targetStrings.push(targetHeader + perProbe);
				}
			}

			let targetStr = targetStrings.join('\n\n---\n\n');
			let link = this.get('measurementLink');
			let footer = link ? `\n\nYou can also view the results at ${link}\n` : '';
			this.set('markdownResults', resultTitle + targetStr + footer);
		},
	};
</script>
